import axios from "axios";
let axiosInstance = axios.create({
        withCredentials: true
});

const login = async (email, password) => {
  var formdata = new FormData();
//add three variable to form
  formdata.append("email", email);
  formdata.append("password", password);
  return axiosInstance.post("https://n3rve.fly.dev/auth/login?email=".concat(email).concat("&password=").concat(password), {withCredentials: true},formdata)
}

export {
    axiosInstance,
    login
};
